import { Button, useNavigate, useI18n, useClient, useAppStateStore, getQueryKey } from '@ywwwtseng/react-kit';
import {
  Typography,
  useShare,
} from '@ywwwtseng/tma-react-kit';
import {
  ArrowUp,
  ArrowDown,
  Users,
  // Gem,
} from 'lucide-react';
import { RedPackage } from '@/components/icons';
import { useConnectedGuard } from '@/hooks/useConnectedGuard';
import { useToken } from '@/hooks/useToken';
import { useNetwotks } from '@/hooks/useNetwotks';
import { useShareUrl } from '@/hooks/useShareUrl';
import type { Gift } from '@/types';

export function Operation({ tokenId }: { tokenId?: string }) {
  const { query } = useClient();
  const { t } = useI18n();
  const { update } = useAppStateStore();
  const share = useShare();
  const navigate = useNavigate();
  const { share_url } = useShareUrl();
  const token = useToken(tokenId);
  const networks = useNetwotks();

  const tryWithdraw = useConnectedGuard(
    () => {
      if (tokenId) {
        navigate('Withdraw', { params: { token_id: tokenId } });
      } else {
        navigate('Withdraw');
      }
    },
    { network: token?.network }
  );

  const tryDeposit = useConnectedGuard(
    () => {
      if (tokenId) {
        navigate('Deposit', { params: { token_id: tokenId } });
      } else {
        navigate('Deposit');
      }

    },
    { network: token?.network }
  );

  return (
    <div className="h-stack w-full gap-2 !justify-around">
      <div className="v-stack gap-1">
        <Button
          disabled={Boolean(
            token?.network && !networks?.includes(token.network)
          )}
          variant="icon"
          color="secondary"
          size="md"
          onClick={() => {
            void tryWithdraw();
          }}
        >
          <ArrowUp size={24} strokeWidth={2} />
        </Button>
        <Typography size="1" weight={500} i18n="common.withdraw" />
      </div>
      <div className="v-stack gap-1">
        <Button
          disabled={Boolean(
            token?.network && !networks?.includes(token.network)
          )}
          variant="icon"
          color="secondary"
          size="md"
          onClick={() => {
            void tryDeposit();
          }}
        >
          <ArrowDown size={24} strokeWidth={2} />
        </Button>
        <Typography size="1" weight={500} i18n="common.deposit" />
      </div>
      <div className="v-stack gap-1">
        <Button
          variant="icon"
          color="secondary"
          size="md"
          onClick={() => {
            navigate('CreateGift');
          }}
        >
          <RedPackage width={22} height={22} />
        </Button>
        <Typography size="1" weight={500} i18n="common.gift" />
      </div>
      <div className="v-stack gap-1">
        <Button
          variant="icon"
          color="secondary"
          size="md"
          onClick={async () => {
            if (share_url) {
              const res = await query('user_gifts', { type: 'share', limit: 1 });
              const [gift] = (res.data.commands?.[0]?.payload || []) as Gift[];

              if (gift) {
                update([
                  {
                    type: 'update',
                    target: getQueryKey('user_gifts', { id: gift.id }),
                    payload: gift,
                  },
                ]);
                navigate('ShareGift', { params: { gift_id: gift.id } });
                return;
              }

              share({
                url: share_url,
                text: t('share.text'),
              });
            }
          }}
        >
          <Users size={22} />
        </Button>
        <Typography size="1" weight={500} i18n="common.share" />
      </div>
    </div>
  );
}
